import React from 'react';
import PropTypes from 'prop-types';

import './PenNameList.scss';
import AuthorAvatar from 'components/nav/authenticated/AuthorAvatar';
import PreferenceActionCreator from 'actions/PreferenceActionCreator';
import PreferenceStore from 'stores/PreferenceStore';
import { Link } from 'react-router';
import PlusIcon from 'components/shared/icons/PlusIcon';

const PEN_NUM_LIMIT = 3;
class PenNameList extends React.Component {
  static propTypes = {
    identities: PropTypes.arrayOf(PropTypes.shape({
      customerId: PropTypes.string.isRequired,
      amazonAuthorId: PropTypes.string.isRequired,
      claimedAuthorName: PropTypes.string.isRequired,
    })).isRequired,
    isMobile: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  switchIdentity(nextAuthorId) {
    const { currentAuthorId } = PreferenceStore.getState();
    if (nextAuthorId && nextAuthorId !== currentAuthorId) {
      PreferenceActionCreator.updatePreference(
        this.props.identities[0].customerId,
        { currentAuthorId: nextAuthorId },
      );
      // Ensures that current AJAX requests complete before reloading
      $(document).ajaxStop(() => {
        window.location.href = new URL(`${window.location.origin}/home`).href;
      });
    }
  }

  renderPenNames() {
    const { currentAuthorId } = PreferenceStore.getState();
    const { identities } = this.props;
    const filteredIdentities = identities
      .filter(({ amazonAuthorId }) => currentAuthorId !== amazonAuthorId);

    return filteredIdentities.map(({ amazonAuthorId, claimedAuthorName }) => (
      <li
        tabIndex="0"
        key={amazonAuthorId}
        className="clean-list"
        onClick={() => this.switchIdentity(amazonAuthorId)}
      >
        <a href="#" className={this.props.isMobile ? 'aa-nav-link add-pen-name' : 'add-pen-name'}>
          <AuthorAvatar authorName={claimedAuthorName} amazonAuthorId={amazonAuthorId} />
          <span>{claimedAuthorName}</span>
        </a>
      </li>
    ));
  }

  render() {
    const { getString } = this.context;
    const { identities } = this.props;
    const showPenNames = identities && identities.length > 1;
    let className = 'aa-pen-name ';
    const claimLimitNotReached = (identities.length < PEN_NUM_LIMIT);

    className += this.props.isMobile ? 'mobile-pen-list' : 'desktop-pen-list';
    return (
      <ul className={className}>
        {showPenNames ? this.renderPenNames() : null}
        {claimLimitNotReached ? (
          <li className="clean-list">
            <Link to="/books/add" className={this.props.isMobile ? 'aa-nav-link add-pen-name' : 'add-pen-name'}>
              <span className="add-pen-name-icon"><PlusIcon /></span>
              <span>
                {getString('AA_Add_Pen_Name')}
              </span>
            </Link>
          </li>
        ) : null}
      </ul>
    );
  }
}

export default PenNameList;
